import React, { useState } from 'react';
import Downshift from 'downshift';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import LoadableList from './loadable-list';

export default function SearchableSelect(props) {
  const {
    suggestions,
    TextFieldProps,
    error,
    helperText,
    loadableListProps = {},
    itemUniqueId,
    dirty,
    onBlur = Function.prototype,
    required,
    disabled = false,
    autoSelectSingleItem = false,
    onAutoSelect = Function.prototype,
    ...rest
  } = props;

  const [loading, setLoading] = useState(false);
  const [shouldDisable, setShouldDisable] = useState(false);
  const [hasAutoSelected, setHasAutoSelected] = useState(false);

  return (
    <Downshift {...rest}>
      {({
        getInputProps,
        getItemProps,
        getMenuProps,
        isOpen,
        inputValue,
        selectedItem,
        itemToString,
        clearItems,
        setHighlightedIndex,
        setItemCount,
        highlightedIndex,
        clearSelection,
        selectItem,
        reset,
        openMenu,
      }) => {
        const wrappedSuggestions = autoSelectSingleItem
          ? (searchText) => {
            return suggestions(searchText).then((data) => {
              if (data && data.length === 1 && !hasAutoSelected && !selectedItem) {
                setTimeout(() => {
                  selectItem(data[0]);
                  onAutoSelect(data[0]);
                  setShouldDisable(true);
                  setHasAutoSelected(true);
                }, 100);
              } else if (data && data.length > 1) {
                setShouldDisable(false);
              }
              return data;
            });
          }
          : suggestions;

        return (
          <div style={{ width: '100%' }}>
            <TextField
              fullWidth
              required={required}
              disabled={disabled || shouldDisable}
              error={error}
              helperText={helperText}
              InputProps={{
                ...getInputProps({
                  placeholder: props.placeholder,
                  value: inputValue || '',
                  onFocus: openMenu,
                  onChange: () => (!loadableListProps.once ? setLoading(true) : null),
                  onBlur: (e) => {
                    setLoading(false);
                    e.preventDefault();

                    if (e.target.value === '') {
                      clearSelection();
                      selectItem({});
                      reset();
                    }

                    onBlur(e);
                  },
                }),
                endAdornment: (
                  <InputAdornment position="end">
                    {loading ? <CircularProgress color="primary" size={20} /> : null}
                    <ArrowDropDownIcon
                      style={{ cursor: 'pointer', marginLeft: 8 }}
                      onClick={(e) => {
                        e.stopPropagation();
                        openMenu();
                      }}
                    />
                  </InputAdornment>
                ),
              }}
              {...TextFieldProps}
            />

            <div style={{ position: 'relative', zIndex: 1, height: 0 }} {...getMenuProps()}>
              <Paper style={{ display: isOpen ? 'block' : 'none' }} square>
                <LoadableList
                  {...{
                    dirty,
                    getItemProps,
                    selectedItem,
                    itemToString,
                    highlightedIndex,
                    itemUniqueId: itemUniqueId || itemToString,
                  }}
                  query={inputValue || ''}
                  loader={wrappedSuggestions}
                  onFilter={(data) => {
                    if (data) {
                      setItemCount(data.length);
                      setHighlightedIndex(data.length ? 0 : null);
                    }
                  }}
                  onLoad={(data) => {
                    setLoading(false);
                    if (data) {
                      clearItems();
                      setItemCount(data.length);
                      setHighlightedIndex(data.length ? 0 : null);
                    }
                  }}
                  {...loadableListProps}
                />
              </Paper>
            </div>
          </div>
        );
      }}
    </Downshift>
  );
}
